exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1WAkxo6vUv_3pqlCMxxN6o {\n  font-size: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n._2cS3Q81WE_GwRrNH0nibnX {\n  margin: 0 auto;\n}\n._2cUiBeYKhMQQ4q8MB-07da {\n  font-size: 11px;\n}\n", ""]);
// Exports
exports.locals = {
	"compactText": "_1WAkxo6vUv_3pqlCMxxN6o",
	"centered": "_2cS3Q81WE_GwRrNH0nibnX",
	"fontBadge": "_2cUiBeYKhMQQ4q8MB-07da"
};